import {isProduction} from "../../configs/service"
import createApiServices from "./createApiServices"

const prefixURL = isProduction
    ? 'https://fulfillment.merchize.com/api/platform'
    : 'https://fulfillment-staging.merchize.com/api/platform'
const api = createApiServices({baseUrl: prefixURL})

export const updateRequestPhoto = (requestId, formData) => {
    return api.makeAuthRequest({
        url: `/request-photo/${requestId}`,
        method: 'PUT',
        data: formData,
        timeout: 0,
    })
}
